import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Service from './Service.js';
import keyCodes from '../utils/keyCodes.js';

class Key extends Service {
  constructor() {
    super(...arguments);

    _defineProperty(this, "event", {});

    _defineProperty(this, "triggered", 0);

    _defineProperty(this, "previousEvent", {});
  }

  init() {
    this.handler = event => {
      this.event = event;
      this.trigger(this.props);
    };

    document.addEventListener('keydown', this.handler, {
      passive: false
    });
    document.addEventListener('keyup', this.handler, {
      passive: false
    });
    return this;
  }

  kill() {
    document.removeEventListener('keydown', this.handler);
    document.removeEventListener('keyup', this.handler);
    return this;
  }

  get props() {
    var keys = Object.entries(keyCodes).reduce((acc, _ref) => {
      var [name, code] = _ref;
      acc[name] = code === this.event.keyCode;
      return acc;
    }, {});

    if (!this.previousEvent.type) {
      this.triggered = 0;
    }

    if (this.event.type === 'keydown' && this.previousEvent.type === 'keydown') {
      this.triggered += 1;
    } else {
      this.triggered = 1;
    }

    this.previousEvent = this.event;
    return _objectSpread({
      event: this.event,
      triggered: this.triggered,
      direction: this.event.type === 'keydown' ? 'down' : 'up',
      isUp: this.event.type === 'keyup',
      isDown: this.event.type === 'keydown'
    }, keys);
  }

}

var key = null;
export default function useKey() {
  if (!key) {
    key = new Key();
  }

  var add = key.add.bind(key);
  var remove = key.remove.bind(key);
  var has = key.has.bind(key);

  var props = () => key.props;

  return {
    add,
    remove,
    has,
    props
  };
}